<div class="jumbotron text-center">
  <div class="container">
    <div class="row">
      <div class="col-sm-6" style="text-align:left">
        <button type="button" class="btn btn-outline-primary" (click)="open(content)">Add Leave Request
        </button>
      </div>
      <div class="col-sm-6">
        <div class="input-group">
          <button type="button" class="btn btn-outline-success" (click)="clearFilter()">Refresh
          </button>
          <input type="month" class="form-control" style="padding: 0px;" (change)="filterDate()"
            [(ngModel)]="filter_date" id="date">
        </div>
      </div>
    </div>
    <br>
      <div class="row">
        <div class="col-sm-12 table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr class="table-secondary">
                <th>#</th>
                <th>Employee </th>
                <th>From </th>
                <th>To </th>
                <th>days </th>
                <th>Leave Type </th>
                <th>Notes </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @if (list_length == 0) {
                <tr>
                  <td colspan="6">No data found </td>
                </tr>
              }
              @for (item of items; track item; let i = $index) {
                <tr>
                  <td>{{ i+1 }}</td>
                  <td>{{item.employee_name}}</td>
                  <td>{{item.from_date | date:'dd/MM/yyyy'}}</td>
                  <td>{{item.to_date | date:'dd/MM/yyyy'}}</td>
                  <td>{{item.dayDiff}}</td>
                  <td>{{item.leave_type}}</td>
                  <td>{{item.notes}}</td>
                  <td>
                    <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group"
                      dir="auto">
                      <button [disabled]="!utility.isAdmin()" type="button" class="btn btn-danger"
                        (click)="onDelete(item.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                          fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                          <path
                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                          <path fill-rule="evenodd"
                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                        </svg>
                      </button>
                      <button type="button" class="btn btn-secondary" (click)="edit(content2, item)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                          fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                          <path
                            d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                          <path fill-rule="evenodd"
                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-md-8 col-lg-9" style="text-align:left">
          <ngb-pagination [collectionSize]="items.length" [(page)]="page" [maxSize]="10" [rotate]="true"
          [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">New Leave </h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="employee_id" class="form-label">Employee </label>
        <select class="form-select" [(ngModel)]="item.employee_id" id="employee_id">
          @for (employee of employees; track employee) {
            <option [value]='employee.id'>{{employee.name}}</option>
          }
        </select>
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col">
            <label for="from_date" class="form-label">From </label>
            <input type="date" class="form-control" [(ngModel)]="item.from_date" id="from_date">
          </div>
          <div class="col">
            <label for="to_date" class="form-label">To </label>
            <input type="date" class="form-control" [(ngModel)]="item.to_date" id="to_date">
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label for="leave_type" class="form-label">Leave Type </label>
        <select class="form-select" [(ngModel)]="item.leave_type" id="leave_type">
          <option value="0">--- Select ---</option>
          <option value='ANNUAL'>Annual</option>
          <option value='SICK'>Sick</option>
          <option value='PERSONAL'>Without Payment</option>
        </select>
      </div>
      <div class="mb-3">
        <label for="notes" class="form-label">Notes </label>
        <textarea class="form-control" [(ngModel)]="item.notes" id="notes" rows="4" cols="50"></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnSubmit()">Add </button>
    </div>
  </ng-template>

  <ng-template #content2 let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Update Leave </h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="employee_id" class="form-label">Employee </label>
        <select class="form-select" [(ngModel)]="new_item.employee_id" id="employee_id">
          @for (employee of employees; track employee) {
            <option [value]='employee.id'>{{employee.name}}</option>
          }
        </select>
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col">
            <label for="from_date" class="form-label">From </label>
            <input type="date" class="form-control" [(ngModel)]="new_item.from_date" id="from_date">
          </div>
          <div class="col">
            <label for="to_date" class="form-label">To </label>
            <input type="date" class="form-control" [(ngModel)]="new_item.to_date" id="to_date">
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label for="leave_type" class="form-label">Leave Type </label>
        <select class="form-select" [(ngModel)]="new_item.leave_type" id="leave_type">
          <option value="0">--- Select ---</option>
          <option value='ANNUAL'>Annual</option>
          <option value='SICK'>Sick</option>
          <option value='LEAVE'>Leave</option>
          <option value='LONG'>Long</option>
          <option value='PERSONAL'>Personal</option>
          <option value='OTHER'>Other</option>
        </select>
      </div>
      <div class="mb-3">
        <label for="notes" class="form-label">Notes </label>
        <textarea class="form-control" [(ngModel)]="new_item.notes" id="notes" rows="4" cols="50"></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnUpdate(new_item_id)">Update
      </button>
    </div>
  </ng-template>